import { escapeHtml, escapeHtmlBr, extractionrAreaCodeData } from '../utilities/index'

export default class castInfo {

  constructor() {
    this.el = document.querySelector('.js-castInfo')

    if (!this.el) {
      return
    }

    this.createCastInfo()
  }

  castInfoDetailHtml(data) {
    let html = '<div>'

    for (let i = 0; i < data.length; i++) {
      const item = data[i]

      html += `
        <dl class="fr-sp-pt-m fr-pc-pt-m">
          <dt class="castInfo_detailName">${escapeHtmlBr(item.store_name)}</dt>
          <dd class="fr-sp-pt-s fr-pc-pt-s">${escapeHtmlBr(item.remarks)}</dd>
        </dl>
      `
    }

    html += '</div>'

    return html
  }

  createCastInfo() {
    const castInfoData = extractionrAreaCodeData(
      '01',
      window.LIVESTATION.MAINCONTENT
    )[0]
    const castInfoDetailData = extractionrAreaCodeData(
      '02',
      window.LIVESTATION.MAINCONTENT
    )

    if (!castInfoData || !castInfoDetailData.length) {
      return
    }

    const castInfoHtml = `
      <h3 class="fr-heading -h3 fr-sp-py-s fr-pc-py-s">${escapeHtmlBr(
      castInfoData.store_name
    )}</h3>
      <p class="u-color-gray500">${escapeHtmlBr(castInfoData.store_url.pc)}</p>

      <div class="fr-sp-mt-m fr-pc-mt-m">
        <div class="u-imgAdjustBox" data-aspect-ratio="823:412">
          <picture class="u-imgAdjustBox_inner">
            <source srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-srcset="${escapeHtml(
      castInfoData.store_url.sp
    )}" type="image/jpeg"/>
            <img class="fr-img lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${escapeHtml(
      castInfoData.store_url.sp
    )}" alt="" data-expand="300">
          </picture>
        </div>
      </div>
      <p class="fr-sp-pt-m fr-pc-pt-l">${escapeHtmlBr(castInfoData.remarks)}</p>

      <div class="castInfo_detail fr-sp-mt-xl fr-pc-mt-l">
        <h4 class="castInfo_detailHeading">${escapeHtmlBr(castInfoData.free)}</h4>
        ${this.castInfoDetailHtml(castInfoDetailData)}
      </div>
    `

    this.el.innerHTML = castInfoHtml
  }
}
